/* eslint-disable no-underscore-dangle */
import actions from "./actions";
import { setErrorReducer, setRequestReducer, setSuccessReducer } from "../helper";
import { Helper } from "./Helper";
import convert from 'xml-js';
import { MyInvoisDocumentType } from "../../enums/MyInvoisDocumentType";

const initState = {
    myInvoisDocument: {
        items: [],
        taxMode: null,
    },
    myInvoisDocumentSummaryData: {
        subtotal: 0,
        discount: 0,
        bundle_discount: 0,
        sales_tax: 0,
        service_tax_6: 0, // 6% service tax (SV6)
        service_tax_8: 0, // 8% service tax (SV8)
        service_tax_exempted: 0,

        service_tax_6_taxable_amount: 0,
        service_tax_8_taxable_amount: 0,

        tax: 0,
        total: 0,
    },
    myInvoisDocumentTaxSummary: [
        // {
        //     TaxCode: 'Sales Tax',
        //     TaxableAmount: 0,
        //     TaxAmount: 0,
        // },
    ],
    myInvoisDocumentReadState: false,

    myInvoisDocuments: [],
    myInvoisDocumentsPagination: {},
    myInvoisDocumentsReadAllState: false,
    lastReadAllDocumentsRequest: {},

    myInvoisIncomingDocument: {
        items: [],
        taxMode: null,
    },

    myInvoisIncomingDocuments: [],
    myInvoisIncomingDocumentsPagination: {},
    myInvoisIncomingDocumentsReadAllState: false,

    myInvoisResubmitDocumentState: false,
    myInvoisBulkResubmitDocumentsState: false,
    myInvoisBulkResubmitDocumentsResult: null,

    myInvoisCancelDocumentState: false,

    // Transactions
    myInvoisTransactions: [],
    myInvoisTransactionsPagination: {},
    myInvoisTransactionsReadAllState: false,
    lastReadAllTransactionsRequest: {},

    myInvoisBulkSubmitTransactionsState: false,
    myInvoisSubmitTransactionState: false,

    // MyInvois Document Status
    myInvoisDocumentStatus: null,

    // refetching MyInvois Document Status
    myInvoisDocumentStatusRefetchState: false,

    // MiniPOS
    myInvoisMiniPos: [],
    myInvoisMiniPosPagination: {},
    myInvoisMiniPosReadAllState: false,
    lastReadAllMiniPosRequest: {},

    myInvoisBulkSubmitMiniPosState: false,
    myInvoisSubmitMiniPosState: false,

    myInvoisSubmitMiniPosForConsolidatedState: false,

    miniPosConsolidatedOrders: [],
    miniPosConsolidatedOrdersPagination: {},
    miniPosConsolidatedOrdersSummary: {},
    miniPosConsolidatedOrdersReadAllState: false,

    // Consolidated
    // allowed submittable
    myInvoisSubmittableConsolidatedTransactions: [],
    myInvoisSubmittableConsolidatedTransactionsPagination: {},
    myInvoisSubmittableConsolidatedTransactionsSummary: {},
    myInvoisSubmittableConsolidatedTransactionsReadAllState: false,

    // unsubmittable
    myInvoisUnsubmittableConsolidatedTransactions: [],
    myInvoisUnsubmittableConsolidatedTransactionsPagination: {},
    myInvoisUnsubmittableConsolidatedTransactionsSummary: {},
    myInvoisUnsubmittableConsolidatedTransactionsReadAllState: false,

    myInvoisSubmitTransactionsForConsolidatedState: false,

    myInvoisTinRegNoIsValid: null,
    myInvoisValidateTinRegNoState: false,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.MYINVOIS_READ_DOCUMENT_REQUEST:
            return setRequestReducer(state, 'myInvoisDocumentReadState');
        case actions.MYINVOIS_READ_DOCUMENT_SUCCESS: {
            const {
                payload_xml,
                type: originalDocumentType,
            } = action.myInvoisDocument;

            const jsonStr = convert.xml2json(payload_xml, {
                compact: true,
                spaces: 2,
            });

            const payloadJson = JSON.parse(jsonStr);

            console.log('aaa MYINVOIS_READ_DOCUMENT_SUCCESS', {
                payloadJson,
                payload_xml,
                jsonStr,
                myInvoisDocument: action.myInvoisDocument,
            });

            const accountingSupplierParty = payloadJson.Invoice["cac:AccountingSupplierParty"]["cac:Party"];
            const accountingCustomerParty = payloadJson.Invoice["cac:AccountingCustomerParty"]["cac:Party"];
            const invoiceLines = payloadJson.Invoice["cac:InvoiceLine"];
            const billingReferences = payloadJson.Invoice["cac:BillingReference"];
            const additionalReferences = payloadJson.Invoice["cac:AdditionalDocumentReference"] ?? [];

            const supplierInfo = Helper
                .parseAccountingParty(accountingSupplierParty, action.countries, action.countryStates);
            const customerInfo = Helper
                .parseAccountingParty(accountingCustomerParty, action.countries, action.countryStates);
            const invoiceItems = Helper.parseInvoiceLines(invoiceLines);
            const relatedDocuments = Helper.parseBillingReferences(billingReferences);
            const customFields = Helper.parseAdditionalReferences(additionalReferences);

            console.log('aaa MYINVOIS_READ_DOCUMENT_SUCCESS', {
                payloadJson,
                payload_xml,
                supplierInfo,
                customerInfo,
                invoiceItems,
            });
            const taxSummary = Helper.parseTaxSummary(payloadJson.Invoice["cac:TaxTotal"]);
            console.log('aaa taxSummary', taxSummary);

            // const taxMode = payload.TaxInclusive ? 'inclusive' : 'exclusive';
            const taxMode = 'exclusive'; // always exclusive since invoiceItems is parsed from xml
            const isRoundingOn = !!payloadJson.Invoice["cac:LegalMonetaryTotal"]["cbc:PayableRoundingAmount"]?._text;

            // Parse items from payload
            const parsedItems = Helper.parseMyInvoisDocumentItems(
                invoiceItems || [], action.taxCodes, action.myInvoisDocument, taxMode);

            // Get summaryData
            const myInvoisDocumentSummaryData = Helper.getSummaryData(
                parsedItems,
                taxMode,
                isRoundingOn,
                payloadJson.Invoice["cac:LegalMonetaryTotal"],
                payloadJson.Invoice["cac:TaxTotal"]["cbc:TaxAmount"]?._text,
                payloadJson.Invoice["cac:AllowanceCharge"], // for bundle discount
            );

            const returnMyInvoisDocument = {
                ...action.myInvoisDocument, // other data, eg document_uuid, type, status, issued_at etc.

                // Additionally parsed data from 'payload' in action.myInvoisDocument
                items: parsedItems,
                tax_mode: taxMode,
                customs_form_no: customFields.CustomsImportForm,
                customs_k2_form_no: customFields.K2,
                incoterms: customFields.Incoterms,
                supplier_info: supplierInfo,
                customer_info: customerInfo,
                related_documents: relatedDocuments,

                // if is minipos order, do a bit of tweaking to match the frontend expected structure
                ...originalDocumentType === MyInvoisDocumentType.MINIPOS_ORDER ? {
                    transactions: action.myInvoisDocument.orders,
                } : {},
            };

            console.log('aaa MYINVOIS_READ_DOCUMENT_SUCCESS', {
                payloadJson,
                myInvoisDocument: action.myInvoisDocument,
                returnMyInvoisDocument,
                myInvoisDocumentSummaryData,
                taxSummary,
            });

            return setSuccessReducer(state, 'myInvoisDocumentReadState', {
                myInvoisDocument: returnMyInvoisDocument,
                myInvoisDocumentSummaryData,
                myInvoisDocumentTaxSummary: taxSummary,
                myInvoisDocumentIsRoundingOn: isRoundingOn,
            });
        }
        case actions.MYINVOIS_READ_DOCUMENT_ERROR:
            return setErrorReducer(state, 'myInvoisDocumentReadState');

        case actions.MYINVOIS_READ_ALL_DOCUMENTS_REQUEST:
            return setRequestReducer(state, 'myInvoisDocumentsReadAllState');
        case actions.MYINVOIS_READ_ALL_DOCUMENTS_SUCCESS:
            return setSuccessReducer(state, 'myInvoisDocumentsReadAllState', {
                myInvoisDocuments: action.myInvoisDocuments,
                myInvoisDocumentsPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
                lastReadAllDocumentsRequest: action.request,
            });
        case actions.MYINVOIS_READ_ALL_DOCUMENTS_ERROR:
            return setErrorReducer(state, 'myInvoisDocumentsReadAllState');

        case actions.MYINVOIS_RESET_DOCUMENTS:
        case actions.MYINVOIS_RESET_DOCUMENT:
        case actions.MYINVOIS_RESET_ALL:
        case actions.MYINVOIS_RESET_INCOMING_DOCUMENTS:
            return { ...initState };
        case actions.MYINVOIS_RESET_INCOMING_DOCUMENT:
            return { ...state,
                myInvoisIncomingDocument: {
                    items: [],
                    taxMode: null,
                } };

        case actions.MYINVOIS_RESUBMIT_DOCUMENT_REQUEST:
            return setRequestReducer(state, 'myInvoisResubmitDocumentState');
        case actions.MYINVOIS_RESUBMIT_DOCUMENT_SUCCESS:
            return setSuccessReducer(state, 'myInvoisResubmitDocumentState');
        case actions.MYINVOIS_RESUBMIT_DOCUMENT_ERROR:
            return setErrorReducer(state, 'myInvoisResubmitDocumentState');

        case actions.MYINVOIS_BULK_RESUBMIT_DOCUMENTS_REQUEST:
            return setRequestReducer(state, 'myInvoisBulkResubmitDocumentsState');
        case actions.MYINVOIS_BULK_RESUBMIT_DOCUMENTS_SUCCESS:
            return setSuccessReducer(state, 'myInvoisBulkResubmitDocumentsState');
        case actions.MYINVOIS_BULK_RESUBMIT_DOCUMENTS_ERROR:
            return setErrorReducer(state, 'myInvoisBulkResubmitDocumentsState');

        case actions.MYINVOIS_CANCEL_DOCUMENT_REQUEST:
            return setRequestReducer(state, 'myInvoisCancelDocumentState');
        case actions.MYINVOIS_CANCEL_DOCUMENT_SUCCESS:
            return setSuccessReducer(state, 'myInvoisCancelDocumentState');
        case actions.MYINVOIS_CANCEL_DOCUMENT_ERROR:
            return setErrorReducer(state, 'myInvoisCancelDocumentState');

        case actions.MYINVOIS_READ_ALL_TRANSACTIONS_REQUEST:
            return setRequestReducer(state, 'myInvoisTransactionsReadAllState');
        case actions.MYINVOIS_READ_ALL_TRANSACTIONS_SUCCESS:
            return setSuccessReducer(state, 'myInvoisTransactionsReadAllState', {
                myInvoisTransactions: action.myInvoisTransactions,
                myInvoisTransactionsPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
                lastReadAllTransactionsRequest: action.request,
            });
        case actions.MYINVOIS_READ_ALL_TRANSACTIONS_ERROR:
            return setErrorReducer(state, 'myInvoisTransactionsReadAllState');

        case actions.MYINVOIS_BULK_SUBMIT_TRANSACTIONS_REQUEST:
            return setRequestReducer(state, 'myInvoisBulkSubmitTransactionsState');
        case actions.MYINVOIS_BULK_SUBMIT_TRANSACTIONS_SUCCESS:
            return setSuccessReducer(state, 'myInvoisBulkSubmitTransactionsState');
        case actions.MYINVOIS_BULK_SUBMIT_TRANSACTIONS_ERROR:
            return setErrorReducer(state, 'myInvoisBulkSubmitTransactionsState');

        case actions.MYINVOIS_SUBMIT_TRANSACTION_REQUEST:
            return setRequestReducer(state, 'myInvoisSubmitTransactionState');
        case actions.MYINVOIS_SUBMIT_TRANSACTION_SUCCESS:
            return setSuccessReducer(state, 'myInvoisSubmitTransactionState');
        case actions.MYINVOIS_SUBMIT_TRANSACTION_ERROR:
            return setErrorReducer(state, 'myInvoisSubmitTransactionState');

        case actions.MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_REQUEST:
            return setRequestReducer(state, 'myInvoisDocumentStatusRefetchState');
        case actions.MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_SUCCESS:
            return setSuccessReducer(state, 'myInvoisDocumentStatusRefetchState', {
                myInvoisDocumentStatus: action.transactionDocumentStatus,
            });
        case actions.MYINVOIS_REFETCH_TRANSACTION_DOCUMENT_STATUS_ERROR:
            return setErrorReducer(state, 'myInvoisDocumentStatusRefetchState');

        case actions.MYINVOIS_REFETCH_DOCUMENT_STATUS_REQUEST: {
            return setRequestReducer(state, 'myInvoisDocumentStatusRefetchState');
        }
        case actions.MYINVOIS_REFETCH_DOCUMENT_STATUS_SUCCESS: {
            return setSuccessReducer(state, 'myInvoisDocumentStatusRefetchState', {
                myInvoisDocumentStatus: action.documentStatus,
            });
        }
        case actions.MYINVOIS_REFETCH_DOCUMENT_STATUS_ERROR:
            return setErrorReducer(state, 'myInvoisDocumentStatusRefetchState');

        // ----------------- MINIPOS  ----------------- //
        case actions.MYINVOIS_READ_ALL_MINIPOS_REQUEST:
            console.log('aaa MYINVOIS_READ_ALL_MINIPOS_REQUEST', {
                action,
            });
            return setRequestReducer(state, 'myInvoisMiniPosReadAllState');
        case actions.MYINVOIS_READ_ALL_MINIPOS_SUCCESS:
            console.log('aaa MYINVOIS_READ_ALL_MINIPOS_SUCCESS', {
                myInvoisMiniPos: action.myInvoisMiniPos,
                pagination: action.pagination,
                request: action.request,
            });
            return setSuccessReducer(state, 'myInvoisMiniPosReadAllState', {
                myInvoisMiniPos: action.myInvoisMiniPos,
                myInvoisMiniPosPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
                lastReadAllMiniPosRequest: action.request,
            });
        case actions.MYINVOIS_READ_ALL_MINIPOS_ERROR:
            return setErrorReducer(state, 'myInvoisMiniPosReadAllState');

        case actions.MYINVOIS_BULK_SUBMIT_MINIPOS_REQUEST:
            return setRequestReducer(state, 'myInvoisBulkSubmitMiniPosState');
        case actions.MYINVOIS_BULK_SUBMIT_MINIPOS_SUCCESS:
            return setSuccessReducer(state, 'myInvoisBulkSubmitMiniPosState');
        case actions.MYINVOIS_BULK_SUBMIT_MINIPOS_ERROR:
            return setErrorReducer(state, 'myInvoisBulkSubmitMiniPosState');

        case actions.MYINVOIS_SUBMIT_MINIPOS_REQUEST:
            return setRequestReducer(state, 'myInvoisSubmitMiniPosState');
        case actions.MYINVOIS_SUBMIT_MINIPOS_SUCCESS:
            return setSuccessReducer(state, 'myInvoisSubmitMiniPosState');
        case actions.MYINVOIS_SUBMIT_MINIPOS_ERROR:
            return setErrorReducer(state, 'myInvoisSubmitMiniPosState');

        // submittable
        case actions.MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST:
            return setRequestReducer(state, 'myInvoisSubmittableConsolidatedTransactionsReadAllState');
        case actions.MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS:
        case actions.MYINVOIS_READ_UNSUBMITTABLE_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS: {
            const key = action.isSubmittable ? 'myInvoisSubmittable' : 'myInvoisUnsubmittable';

            return setSuccessReducer(state, `${key}ConsolidatedTransactionsReadAllState`, {
                [`${key}ConsolidatedTransactions`]: action.transactions,
                [`${key}ConsolidatedTransactionsPagination`]: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
                [`${key}ConsolidatedTransactionsSummary`]: {
                    transactionCount: action.summary.transaction_count,
                    totalAmount: action.summary.total_amount,
                },
            });
        }
        case actions.MYINVOIS_READ_TRANSACTIONS_FOR_CONSOLIDATED_ERROR:
            return setErrorReducer(state, 'myInvoisSubmittableConsolidatedTransactionsReadAllState');

        case actions.MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_REQUEST:
            return setRequestReducer(state, 'miniPosConsolidatedOrdersReadAllState');
        case actions.MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_SUCCESS: {
            return setSuccessReducer(state, 'miniPosConsolidatedOrdersReadAllState', {
                miniPosConsolidatedOrders: action.orders,
                miniPosConsolidatedOrdersPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
                miniPosConsolidatedOrdersSummary: {
                    orderCount: action.summary.order_count,
                    totalAmount: action.summary.total_amount,
                },
            });
        }
        case actions.MYINVOIS_READ_MINIPOS_FOR_CONSOLIDATED_ERROR:
            return setErrorReducer(state, 'miniPosConsolidatedOrdersReadAllState');

        // unsubmittable
        case actions.MYINVOIS_READ_UNSUBMITTABLE_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST:
            return setRequestReducer(state, 'myInvoisUnsubmittableConsolidatedTransactionsReadAllState');
        case actions.MYINVOIS_READ_UNSUBMITTABLE_TRANSACTIONS_FOR_CONSOLIDATED_ERROR:
            return setErrorReducer(state, 'myInvoisUnsubmittableConsolidatedTransactionsReadAllState');

        case actions.MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_REQUEST:
            return setRequestReducer(state, 'myInvoisSubmitTransactionsForConsolidatedState');
        case actions.MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_SUCCESS:
            return setSuccessReducer(state, 'myInvoisSubmitTransactionsForConsolidatedState');
        case actions.MYINVOIS_SUBMIT_TRANSACTIONS_FOR_CONSOLIDATED_ERROR:
            return setErrorReducer(state, 'myInvoisSubmitTransactionsForConsolidatedState');

        case actions.MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_REQUEST:
            return setRequestReducer(state, 'myInvoisSubmitMiniPosForConsolidatedState');
        case actions.MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_SUCCESS:
            return setSuccessReducer(state, 'myInvoisSubmitMiniPosForConsolidatedState');
        case actions.MYINVOIS_SUBMIT_MINIPOS_FOR_CONSOLIDATED_ERROR:
            return setErrorReducer(state, 'myInvoisSubmitMiniPosForConsolidatedState');

        case actions.MYINVOIS_RESET_TRANSACTIONS_FOR_CONSOLIDATED:
            return {
                ...state,
                myInvoisSubmittableConsolidatedTransactions: [],
                myInvoisSubmittableConsolidatedTransactionsPagination: {},
                myInvoisSubmittableConsolidatedTransactionsSummary: {},

                myInvoisUnsubmittableConsolidatedTransactions: [],
                myInvoisUnsubmittableConsolidatedTransactionsPagination: {},
                myInvoisUnsubmittableConsolidatedTransactionsSummary: {},

                myInvoisSubmitTransactionsForConsolidatedState: false,

                // minipos
                miniPosConsolidatedOrders: [],
                miniPosConsolidatedOrdersPagination: {},
                miniPosConsolidatedOrdersSummary: {},

                myInvoisSubmitMiniPosForConsolidatedState: false,

            };

        case actions.MYINVOIS_VALIDATE_TIN_REG_NO_REQUEST:
            return setRequestReducer(state, 'myInvoisValidateTinRegNoState');
        case actions.MYINVOIS_VALIDATE_TIN_REG_NO_SUCCESS:
            return setSuccessReducer(state, 'myInvoisValidateTinRegNoState', {
                myInvoisTinRegNoIsValid: action.isValid,
            });
        case actions.MYINVOIS_VALIDATE_TIN_REG_NO_ERROR:
            return setErrorReducer(state, 'myInvoisValidateTinRegNoState');

        case actions.MYINVOIS_SET_VALIDATE_TIN_REG_NO_RESULT:
            return {
                ...state,
                myInvoisTinRegNoIsValid: action.isValid,
            };

        case actions.MYINVOIS_READ_INCOMING_DOCUMENT_REQUEST:
            return setRequestReducer(state, 'myInvoisIncomingDocumentReadState');
        case actions.MYINVOIS_READ_INCOMING_DOCUMENT_SUCCESS:
            return setSuccessReducer(state, 'myInvoisIncomingDocumentReadState', {
                ...state,
                myInvoisIncomingDocument: action.myInvoisIncomingDocument,
            });
        case actions.MYINVOIS_READ_INCOMING_DOCUMENT_ERROR:
            return setErrorReducer(state, 'myInvoisIncomingDocumentReadState');

        case actions.MYINVOIS_READ_ALL_INCOMING_DOCUMENTS_REQUEST:
            return setRequestReducer(state, 'myInvoisIncomingDocumentsReadAllState');
        case actions.MYINVOIS_READ_ALL_INCOMING_DOCUMENTS_SUCCESS:
            return setSuccessReducer(state, 'myInvoisIncomingDocumentsReadAllState', {
                myInvoisIncomingDocuments: action.myInvoisIncomingDocuments,
                myInvoisIncomingDocumentsPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
                lastReadAllDocumentsRequest: action.request,
            });
        case actions.MYINVOIS_READ_ALL_INCOMING_DOCUMENTS_ERROR:
            return setErrorReducer(state, 'myInvoisIncomingDocumentsReadAllState');

        case actions.MYINVOIS_DELETE_INCOMING_DOCUMENT_REQUEST:
            return setRequestReducer(state, 'myInvoisIncomingDocumentDeleteState');
        case actions.MYINVOIS_DELETE_INCOMING_DOCUMENT_SUCCESS:
            return setSuccessReducer(state, 'myInvoisIncomingDocumentDeleteState');
        case actions.MYINVOIS_DELETE_INCOMING_DOCUMENT_ERROR:
            return setErrorReducer(state, 'myInvoisIncomingDocumentDeleteState');

        case actions.MYINVOIS_POST_INCOMING_DOCUMENT_REQUEST:
            return setRequestReducer(state, 'myInvoisIncomingDocumentPostState');
        case actions.MYINVOIS_POST_INCOMING_DOCUMENT_SUCCESS:
            return setSuccessReducer(state, 'myInvoisIncomingDocumentPostState');
        case actions.MYINVOIS_POST_INCOMING_DOCUMENT_ERROR:
            return setErrorReducer(state, 'myInvoisIncomingDocumentPostState');

        default:
            return state;
    }
}
